/**
 * Yandex Metrika: how visitors from advertising move on to signing up and
 * paying. The landing page runs the same counter, so a visit that starts there
 * carries on here.
 *
 * Browser only: Telegram puts signed user data in the Mini App address. The
 * address goes out without its query as well, because /auth/telegram carries
 * a sign-in code there. Without VITE_YANDEX_METRIKA_ID everything is a no-op.
 */
type Ym = ((id: number, method: string, ...args: unknown[]) => void) & { a?: IArguments[]; l?: number }

declare global {
  interface Window {
    ym?: Ym
  }
}

const COUNTER_ID = Number(import.meta.env.VITE_YANDEX_METRIKA_ID)

export const metrikaEnabled = Boolean(COUNTER_ID)

export function startMetrika(): void {
  if (!COUNTER_ID || window.ym) return

  const ym = function () {
    ym.a = ym.a ?? []
    ym.a.push(arguments)
  } as Ym
  ym.l = Date.now()
  window.ym = ym

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://mc.yandex.ru/metrika/tag.js'
  document.head.appendChild(script)

  ym(COUNTER_ID, 'init', { defer: true })
  ym(COUNTER_ID, 'hit', location.origin + location.pathname)
}

export function reachGoal(goal: string, params?: Record<string, unknown>): void {
  window.ym?.(COUNTER_ID, 'reachGoal', goal, params)
}

/** The result screen can be reloaded, and a paid order counts once. */
export function reportPayment(orderId: string, amount: number | null): void {
  if (!window.ym) return

  const key = `airoundme.metrika.paid.${orderId}`
  try {
    if (localStorage.getItem(key)) return
    localStorage.setItem(key, '1')
  } catch {
    // Without storage a reload may count twice, which is still better than never
  }
  reachGoal('payment', { order_price: amount, currency: 'RUB' })
}
